import { IRootState } from '../../types/redux/root';

export const kanbanCardsSelector = (root: IRootState) => root.kanban.cards;

export const kanbanColumnCardsSelector = (column: string) => (root: IRootState) => root.kanban.cards.filter((el) => el.column === column);

export const kanbanDraggingCardSelector = (root: IRootState) => root.kanban.dragging;
